import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import UserCardMarketplace from "../../../components/cards/UserCardMarketplace";
import MostLikedCard from "../../../components/cards/filterscards/MostLikedCard";
import MostPopular from "../../../components/cards/filterscards/MostPopular";
import CardMarketplace from "../../../components/cards/CardMarketplace";
import UserCollection from "../../../components/collection/UserCollection";
import Collection3 from "../../../components/collection/Collection3";
import { Link, useNavigate } from "react-router-dom";
import CardAuctions from "../../../components/cards/auction/CardAuctionForAll";

export const MarketData = (props) => {
  // States for handling filters and active tabs
  const [filter, setFilter] = useState("latest");
  const [userActiveTab, setUserActiveTab] = useState("allItems");
  const [activeTab, setActiveTab] = useState("allItems");
 
  // Fetching wallet address from local storage
  const userWalletAddress = localStorage.getItem("WalletAddress");

  // React Router's navigation hook
  const navigate = useNavigate();

  // Function to handle navigation to a specific route
  const redirect = (path, module) => {
    if (module === "user") {
      navigate(path, { state: "user" });
    } else {
      navigate(path);
    }
  };
  console.log("props.filter", props.filter, props.filter);

  // Function to render content for user's NFTs based on active tab
  const renderTabContentForUser = () => {
    switch (userActiveTab) {
      case "allItems":
        return <UserCardMarketplace filter={props.filter} />;
      case "mostLiked":
        return <MostLikedCard filter={props.filter} user={true} />;
      case "popular":
        return <MostPopular filter={props.filter} user={true} />;
      default:
        return null;
    }
  };

  // Function to render content for all NFTs based on active tab
  const renderTabContentForAll = () => {
    switch (activeTab) {
      case "allItems":
        return <CardMarketplace filter={props.filter} />;
      case "mostLiked":
        return <MostLikedCard filter={props.filter} />;
      case "popular":
        return <MostPopular filter={props.filter} />;
      default:
        return null;
    }
  };

  return (
    <div className="container">
      {/* Section for User's NFTs */}
      <div className="section mt-100">
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <h2 className="section__title mb-20">Your NFT</h2>
            {/* Filter Dropdown */}
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">Filter</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setFilter("latest")}>All</Dropdown.Item>
                <Dropdown.Item onClick={() => setFilter("latest")}>Latest</Dropdown.Item>
                <Dropdown.Item onClick={() => setFilter("listed")}>Listed</Dropdown.Item>
                <Dropdown.Item onClick={() => setFilter("not listed")}>
                  Not Listed
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* User Tabs */}
          <div className="custom-tabs mt-4">
            <div className="d-flex align-items-center justify-content-between">
              {/* Tab Buttons */}
              <div className="d-flex mb-4">
                <button
                  className={`btn btn-white btn-sm mx-2 ${userActiveTab === "allItems" ? "btn-dark text-white" : ""
                    }`}
                  onClick={() => setUserActiveTab("allItems")}
                >
                  All Items
                </button>
                <button
                  className={`btn btn-white btn-sm mx-2 ${userActiveTab === "mostLiked" ? "btn-dark text-white" : ""
                    }`}
                  onClick={() => setUserActiveTab("mostLiked")}
                >
                  Most Liked
                </button>
                <button
                  className={`btn btn-white btn-sm ${userActiveTab === "popular" ? "btn-dark text-white" : ""
                    }`}
                  onClick={() => setUserActiveTab("popular")}
                >
                  Popular
                </button>
              </div>
              {/* View All Button */}
              {userWalletAddress && (
                <button
                  className="btn btn-sm btn-white"
                  onClick={() => redirect("/allNFTs", "user")}
                >
                  <i className="ri-restart-line" /> View all
                </button>
              )}
            </div>

            {/* User Tab Content */}
            <div className="tab-content">{renderTabContentForUser()}</div>
          </div>
        </div>
      </div>

      {/* Section for All Categories */}
      <div className="section mt-100">
        <div>
          <div className="d-flex align-items-center justify-content-between">
            <h2 className="section__title mb-20">Categories</h2>
            {/* Filter Dropdown */}
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">Filter</Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setFilter("latest")}>All</Dropdown.Item>
                <Dropdown.Item onClick={() => setFilter("latest")}>Latest</Dropdown.Item>
                <Dropdown.Item onClick={() => setFilter("listed")}>Listed</Dropdown.Item>
                <Dropdown.Item onClick={() => setFilter("not listed")}>
                  Not Listed
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* All Categories Tabs */}
          <div className="custom-tabs mt-4">
            <div className="d-flex align-items-center justify-content-between">
              {/* Tab Buttons */}
              <div className="d-flex mb-4">
                <button
                  className={`btn btn-white btn-sm mx-2 ${activeTab === "allItems" ? "btn-dark text-white" : ""
                    }`}
                  onClick={() => setActiveTab("allItems")}
                >
                  All Items
                </button>
                <button
                  className={`btn btn-white btn-sm mx-2 ${activeTab === "mostLiked" ? "btn-dark text-white" : ""
                    }`}
                  onClick={() => setActiveTab("mostLiked")}
                >
                  Most Liked
                </button>
                <button
                  className={`btn btn-white btn-sm ${activeTab === "popular" ? "btn-dark text-white" : ""
                    }`}
                  onClick={() => setActiveTab("popular")}
                >
                  Popular
                </button>
              </div>
              {/* View All Button */}
              <button
                className="btn btn-sm btn-white"
                onClick={() => redirect("/allNFTs")}
              >
                <i className="ri-restart-line" /> View all
              </button>
            </div>
            {/* All Categories Tab Content */}
            <div className="tab-content">{renderTabContentForAll()}</div>
          </div>
        </div>
      </div>

      {/* Section for User Collections */}
      <div className="section mt-100">
        <UserCollection length={6} />
      </div>

      {/* Section for Collection3 */}
      <div className="section mt-100">
        <Collection3 length={6} viewAll={true} market={true} />
      </div>

      {/* Section for Live Auctions */}
      <div className="section mt-100">
        <div className="d-flex section__head space-x-20 justify-content-between align-items-center">
          <h2 className="section__title text-center">Live Auctions</h2>
          <Link to="/live-auctions" className="btn btn-sm btn-dark">
            View all
          </Link>
        </div>
        <CardAuctions filter={props.filter} nftLength={4} />
      </div>
    </div>
  );
};

export default MarketData;
